import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, doc, getDoc, getDocs, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { app } from "../../credenciales";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import { FaUserPlus, FaUserMinus, FaAnglesRight, FaAnglesLeft } from "react-icons/fa6";

const db = getFirestore(app);

const ProfesorPage = () => {
  const { idProfesor } = useParams();
  const [profesorData, setProfesorData] = useState(null);
  const [actividades, setActividades] = useState([]);
  const [actividadesAsignadas, setActividadesAsignadas] = useState([]);
  const [actividadesDisponibles, setActividadesDisponibles] = useState([]);
  const [selectedAsignar, setSelectedAsignar] = useState([]);
  const [selectedQuitar, setSelectedQuitar] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const profesorRef = doc(db, "usuarios", idProfesor);
        const profesorSnap = await getDoc(profesorRef);

        if (!profesorSnap.exists()) return;
        const profesor = { id: profesorSnap.id, ...profesorSnap.data() };
        setProfesorData(profesor);

        const actividadesSnapshot = await getDocs(collection(db, "actividades"));
        const allActividades = actividadesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        setActividades(allActividades);

        const asignadas = allActividades.filter(act => profesor.actividades?.includes(act.id));
        const disponibles = allActividades.filter(act => !profesor.actividades?.includes(act.id));

        setActividadesAsignadas(asignadas);
        setActividadesDisponibles(disponibles);
      } catch (err) {
        console.error("Error al cargar datos:", err);
      }
    };

    fetchData();
  }, [idProfesor]);

  const actualizarActividades = async (action) => {
    const actividadesIds = action === "add" ? selectedAsignar : selectedQuitar;
    if (actividadesIds.length === 0) return;
  
    try {
      const userRef = doc(db, "usuarios", idProfesor);
  
      if (action === "add") {
        // 👉 Agregar al usuario las actividades
        await updateDoc(userRef, {
          actividades: arrayUnion(...actividadesIds)
        });
  
        // 👉 Agregar al profesor en cada fecha con { id, presente: false }
        for (const idActividad of actividadesIds) {
          const actividadRef = doc(db, "actividades", idActividad);
          const actividadSnap = await getDoc(actividadRef);
          if (!actividadSnap.exists()) continue;
  
          const actividadData = actividadSnap.data();
  
          const fechasActualizadas = actividadData.fechas?.map((fecha) => {
            const profesores = (fecha.profesores || []).filter(p => {
              if (typeof p === "string") return p !== idProfesor;
              return p.id !== idProfesor;
            });
  
            // Verificar si el profesor ya está
            const yaExiste = profesores.some(p => p.id === idProfesor);
  
            if (!yaExiste) {
              profesores.push({
                id: idProfesor,
                presente: false
              });
            }
  
            return {
              ...fecha,
              profesores
            };
          });
  
          await updateDoc(actividadRef, {
            fechas: fechasActualizadas
          });
        }
  
      } else {
        // 👉 Remover las actividades del profesor
        await updateDoc(userRef, {
          actividades: arrayRemove(...actividadesIds)
        });
  
        // 👉 Remover al profesor de las fechas de las actividades
        for (const idActividad of actividadesIds) {
          const actividadRef = doc(db, "actividades", idActividad);
          const actividadSnap = await getDoc(actividadRef);
          if (!actividadSnap.exists()) continue;
  
          const actividadData = actividadSnap.data();
  
          const fechasActualizadas = actividadData.fechas?.map((fecha) => {
            const profesores = (fecha.profesores || []).filter(p => {
                // Si es un string (estructura vieja), lo comparamos directamente
                if (typeof p === "string") return p !== idProfesor;
              
                // Si es un objeto con id (estructura nueva)
                return p.id !== idProfesor;
              });
              
            return {
              ...fecha,
              profesores
            };
          });
  
          await updateDoc(actividadRef, {
            fechas: fechasActualizadas
          });
        }
      }
  
      // 👉 Refrescar la vista
      const newProfesorSnap = await getDoc(userRef);
      const newProfesor = { id: newProfesorSnap.id, ...newProfesorSnap.data() };
  
      const asignadas = actividades.filter(act => newProfesor.actividades?.includes(act.id));
      const disponibles = actividades.filter(act => !newProfesor.actividades?.includes(act.id));
  
      setActividadesAsignadas(asignadas);
      setActividadesDisponibles(disponibles);
      setProfesorData(newProfesor);
      setSelectedAsignar([]);
      setSelectedQuitar([]);
    } catch (err) {
      console.error("Error al actualizar actividades del profesor:", err);
    }
  };
  
  

  return (
    <Container className="py-4">
      <h1 className="titles">Asignar actividades a {profesorData?.name} {profesorData?.lastName}</h1>

      <Row className="mt-4">
        {/* Actividades disponibles */}
        <Col>
          <h5>Actividades disponibles</h5>
          <select multiple value={selectedAsignar} onChange={(e) => setSelectedAsignar(Array.from(e.target.selectedOptions, opt => opt.value))} style={{ width: '100%', height: '180px' }}>
            {actividadesDisponibles.map(act => (
              <option key={act.id} value={act.id}>{act.nombre}</option>
            ))}
          </select>
          <Row className="mt-2">
            <Col className="d-flex gap-2">
              <Button onClick={() => actualizarActividades("add")}><FaUserPlus /> Agregar</Button>
              <Button onClick={() => { setSelectedAsignar(actividadesDisponibles.map(a => a.id)); actualizarActividades("add"); }}><FaAnglesRight /> Agregar Todos</Button>
            </Col>
          </Row>
        </Col>

        {/* Actividades asignadas */}
        <Col>
          <h5>Actividades asignadas</h5>
          <select multiple value={selectedQuitar} onChange={(e) => setSelectedQuitar(Array.from(e.target.selectedOptions, opt => opt.value))} style={{ width: '100%', height: '180px' }}>
            {actividadesAsignadas.map(act => (
              <option key={act.id} value={act.id}>{act.nombre}</option>
            ))}
          </select>
          <Row className="mt-2">
            <Col className="d-flex gap-2">
              <Button onClick={() => actualizarActividades("remove")}><FaUserMinus /> Quitar</Button>
              <Button onClick={() => { setSelectedQuitar(actividadesAsignadas.map(a => a.id)); actualizarActividades("remove"); }}><FaAnglesLeft /> Quitar Todos</Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <h3 className="mt-5">Actividades actuales del profesor</h3>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Nombre de la actividad</th>
            {/* <th>Descripción</th> */}
          </tr>
        </thead>
        <tbody>
          {actividadesAsignadas.map(act => (
            <tr key={act.id}>
              <td>{act.nombre}</td>
             {/*  <td>{act.descripcion}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default ProfesorPage;
